module.exports = __webpack_public_path__ + "btn_google.976692a188.webp";